// React
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from 'react-router-dom';
// MUI
import { Grid, Card, Box, Button, Container, TextField, CardHeader, CardContent, Divider, FormControl } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import RouteConstants from "../../../configs/RouteConstants";
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
// Utils
import { InitialGroupState, GroupSchema } from "./Group.utils";
// Styles
import { StyledForm } from "./Group.styles";
//Third party
import { Form, Formik } from 'formik';
import toast from 'react-hot-toast';
import SpinService from "../../../services/SpinService";
//components
import MenuTable from "./MenuTable";
import usePermissions from "../../../hooks/usePermissions";
import PermissionConstants from "../../../configs/PermissionConstants";

const Group = () => {
    const navigate = useNavigate();
    const userPermissions = usePermissions();
    const spinService = SpinService();
    let { id } = useParams();
    const [fieldsLoaded, setFieldsLoaded] = useState(false);
    const [menus, setMenus] = useState([]);
    const [group, setGroup] = useState(InitialGroupState);
    const [permissions, setPermissions] = useState([]);

    const getMenuAndPermissions = async () => {
        spinService.on();
        const response = await get(EntityConstants.MENU_AND_PERMISSION);
        const data = await response.json();
        spinService.off();
        setMenus(data);
        setFieldsLoaded(true);
    };

    const getGroup = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.GROUPS + `/${id}`);
        const data = await response.json();
        spinService.off();
        setGroup(data);
        setPermissions(data.permissions);
    };

    const addPermission = (id) => {
        const index = permissions.indexOf(id);
        if (index === -1) {
            setPermissions([...permissions, id]);
        } else {
            const newItems = [...permissions.slice(0, index), ...permissions.slice(index + 1)];
            setPermissions(newItems);
        };
    };

    const handleSubmit = async (values) => {
        spinService.on();
        if (values.id === undefined) {
            const response = await post(EntityConstants.GROUPS, { group: { ...values, permissions: permissions } });
            if ([200, 201].indexOf(response.status) > -1) {
                toast.success(MessageContants.GROUP_CREATED);
            }
        } else {
            const response = await put(EntityConstants.GROUPS + `/${values.id}`, { group: { ...values, permissions: permissions } });
            if ([200, 201].indexOf(response.status) > -1) {
                toast.success(MessageContants.GROUP_UPDATED);
            }
        }
        spinService.off();
        navigate(RouteConstants.GROUPS);
    };

    useEffect(() => {
        getMenuAndPermissions();
    }, []);

    useEffect(() => {
        if (fieldsLoaded && id !== undefined) {
            getGroup(Number(id));
        }
    }, [fieldsLoaded, id]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Grid item xs={12} md={12} lg={12}>
                    <Formik
                        enableReinitialize
                        initialValues={group}
                        validationSchema={GroupSchema}
                        onSubmit={values => handleSubmit(values)}
                    >
                        {({ values,
                            touched,
                            errors,
                            dirty,
                            isSubmitting,
                            handleChange,
                            handleBlur,
                            handleSubmit }) => (

                            <Form noValidate onSubmit={handleSubmit}>
                                <Card>
                                    <CardHeader title="Role" />
                                    <CardContent>
                                        <StyledForm>
                                            <FormControl>
                                                <TextField
                                                    variant="outlined"
                                                    required
                                                    id="name"
                                                    label="Name"
                                                    name="name"
                                                    value={values.name}
                                                    onChange={handleChange}
                                                    error={errors.name && touched.name}
                                                />
                                            </FormControl>
                                        </StyledForm>
                                    </CardContent>
                                    <CardHeader title="Permissions *" />
                                    <CardContent>
                                        <StyledForm>
                                            <MenuTable
                                                menuItems={menus}
                                                selectedPermissions={permissions}
                                                onPermissionChange={(id) => addPermission(id)}
                                            />
                                        </StyledForm>
                                    </CardContent>
                                    <Divider />
                                    <Box sx={{ p: 2, textAlign: 'right' }}>
                                        <Link to={RouteConstants.GROUPS}>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                startIcon={<Iconify icon="eva:arrow-back-outline" />}
                                            >
                                                Back
                                            </Button>
                                        </Link>
                                        &nbsp;&nbsp;
                                        {
                                            ((values.id === undefined && userPermissions.has(PermissionConstants.GROUP_CREATE)) || (values.id !== undefined && userPermissions.has(PermissionConstants.GROUP_UPDATE))) &&
                                            <Button
                                                variant="contained"
                                                startIcon={<Iconify icon="eva:save-fill" />}
                                                type="submit"

                                            >
                                                {values.id === undefined ? 'Save' : 'Update'}

                                            </Button>
                                        }
                                    </Box>
                                </Card>
                            </Form>
                        )}
                    </Formik>
                </Grid>
            </Container>
        </React.Fragment>
    )
};

export default Group;